import { Box, Text } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import { useServiceFormatter } from '../hooks/useServiceFormatter';
import { Service } from '@common/types';

type ServiceInfoProps = {
  service: Service;
};

const ServiceInfo: FC<ServiceInfoProps> = ({ service }) => {
  const { t } = useTranslation();
  const { startingPriceFormatter } = useServiceFormatter();

  return (
    <Box
      dataHook={`accordion-service-item-${service.id}`}
      direction="vertical"
      padding="18px"
      borderRadius="8px"
      backgroundColor="#F4EDFF"
      gap="18px"
    >
      <Box gap="3px" direction="vertical">
        <Text size="small" weight="normal">
          {t(`explore.services.${service.displayKey}`)}
        </Text>
        <Text size="small" weight="thin" secondary>
          {t(`profile-page-${service.displayKey}-description`)}
        </Text>
      </Box>
      <Box
        dataHook="starting-price"
        backgroundColor="#E2D8FF"
        borderRadius="2px"
        gap="3px"
        padding="3px 6px 3px 6px"
        textAlign="center"
        width="fit-content"
      >
        <Trans
          i18nKey="profile-page-starting-rates-from-min-price"
          values={{
            amount: startingPriceFormatter(service.minPrice),
          }}
        >
          <Text weight="thin" size="tiny">
            {t('profile-page-starting-rates-from')}
          </Text>
          <Text weight="thin" size="tiny">
            {startingPriceFormatter(service.minPrice)}
          </Text>
        </Trans>
      </Box>
    </Box>
  );
};

export default ServiceInfo;
